import { useEffect, useState } from 'react';
import { Typography, Grid } from '@material-ui/core';
import { styled } from '@mui/material/styles';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import IconButton from '@mui/material/IconButton';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

function IconLabel({
  imageSrc,
  label,
  sortable = false,
  sort = false,
  sortOrder = '',
  tooltip = '',
  sortByThis,
}) {
  const classes = useStyles();
  const [dimensions, setDimensions] = useState({});

  useEffect(() => {
    const img = new Image();
    img.onload = function () {
      if (this.width > this.height) setDimensions({ width: 15 });
      else setDimensions({ height: 15 });
    };
    img.src = imageSrc;
  }, [imageSrc]);

  const CustomWidthTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))({
    [`& .${tooltipClasses.tooltip}`]: {
      maxWidth: 150,
    },
  });

  return (
    <div
      className={classNames(classes.root, sortable ? classes.sortableLabel : null)}
      onClick={() => sortable && sortByThis()}
    >
      <Grid item className={classes.iconBox}>
        <img src={imageSrc} alt="icon" className={classNames(classes.icon)} style={dimensions} />
      </Grid>
      <Grid item style={{ marginLeft: 5 }}>
        <Typography className={classNames(classes.label, sort ? classes.sortableLabel : null)}>
          {label}
        </Typography>
      </Grid>
      {tooltip ? (
        <CustomWidthTooltip title={tooltip} placement="top" disableInteractive>
          <IconButton>
            <InfoOutlinedIcon />
          </IconButton>
        </CustomWidthTooltip>
      ) : (
        ''
      )}
      {sortable && sort ? (
        <Grid item>
          {sortOrder === 'asc' ? (
            <ArrowUpwardIcon className={classes.sortArrow} />
          ) : (
            <ArrowDownwardIcon className={classes.sortArrow} />
          )}
        </Grid>
      ) : null}
    </div>
  );
}

IconLabel.propTypes = {
  imageSrc: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
};

const useStyles = makeStyles(() => ({
  root: {
    justifyContent: 'start',
    alignItems: 'center',
    flexDirection: 'row',
    display: 'flex',
  },
  sortableLabel: {
    cursor: 'pointer',
    fontWeight: 700,
  },
  sortArrow: {
    fontSize: '15px !important',
  },
  label: {
    fontFamily: 'Nunito Sans',
    lineHeight: 1,
    fontSize: '0.8em',
    textAlign: 'left',
    fontWeight: 600,
  },
  icon: {
    // width:73,
    // height:22,
    // height:22,
    //  marginLeft:20
  },
}));

export default IconLabel;
